// LICENSE_CODE ZON
'use strict'; /*jslint node:true, react:true*/
import {useEffect} from 'react';
import zutil from 'zutil';

export const use_scroll_by_hash = ()=>useEffect(()=>{
    let el, hash = (zutil.get(document, 'location.hash') || '')
        .replace(/^#/, '');
    if (!hash || !(el = document.getElementById(hash)))
        return;
    el.scrollIntoView();
}, [zutil.get(document, 'location.hash')]);
